import React from "react";
import { Link, useLocation } from "react-router-dom";

import NotificationUnreadBadge from "../notifications/NotificationUnreadBadge";
import { InvestorSectionIcon } from "./InvestorMetricIcons";
import useNotificationUnreadCount from "../../hooks/useNotificationUnreadCount";
import { INVESTOR_SIDEBAR_NAV, isSharesManagementRoute } from "../../utils/investorNavConfig";

const SHORT_LABELS = {
  "/dashboard/investor": "Overview",
  "/wallet": "Wallet",
  "/investments": "Shares",
  "/my-history/deposits": "History",
  "/notifications": "Alerts",
};

function linkActive(pathname, to) {
  const pathOnly = String(to).split("?")[0];
  if (pathOnly === "/investments") {
    return isSharesManagementRoute(pathname);
  }
  if (pathOnly.startsWith("/my-history")) {
    return pathname.startsWith("/my-history") || pathname === "/transactions";
  }
  return pathname === pathOnly;
}

/**
 * Thumb-friendly primary nav for investor phones / small tablets.
 * Desktop keeps the left sidebar; this bar is CSS-shown only under the mobile breakpoint.
 */
export default function InvestorMobileBottomNav() {
  const { pathname } = useLocation();
  const { unreadCount } = useNotificationUnreadCount();

  return (
    <nav className="investor-bottom-nav" aria-label="Investor primary navigation">
      {INVESTOR_SIDEBAR_NAV.map((item) => {
        const active = linkActive(pathname, item.to);
        const isNotifications = item.to === "/notifications";
        const showUnread = isNotifications && unreadCount > 0;
        const short = SHORT_LABELS[item.to] || item.label;
        return (
          <Link
            key={item.to}
            className={[
              "investor-bottom-nav__item",
              active ? "investor-bottom-nav__item--active" : "",
              showUnread ? "investor-bottom-nav__item--unread" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            to={item.to}
            aria-current={active ? "page" : undefined}
            aria-label={item.label}
          >
            <span className="investor-bottom-nav__icon" aria-hidden>
              {item.icon ? <InvestorSectionIcon name={item.icon} /> : null}
              {showUnread ? (
                <NotificationUnreadBadge count={unreadCount} className="investor-bottom-nav__badge" />
              ) : null}
            </span>
            <span className="investor-bottom-nav__label">{short}</span>
          </Link>
        );
      })}
    </nav>
  );
}
